<template>
  <div>
    <NBar title="充值规则设置" :top="true"/>
    <div class="subject">
      <nut-row v-for="(item,index) in rechargeRule" :key="index" :gutter="10" type="flex" align="center">
        <nut-col :span="10">
          <nut-textinput label="充值金额：" v-model="item.recharge" :clearBtn="false" :disabled="false"
                         class="input"/>
        </nut-col>
        <nut-col :span="10">
          <nut-textinput label="赠送金额：" v-model="item.money" :clearBtn="false" :disabled="false"
                         class="input"/>
        </nut-col>
        <nut-col :span="4" v-if="index != 0">
          <nut-button small icon="cross" class="btn" @click="removeRechargeRule(index)"/>
        </nut-col>
      </nut-row>
      <nut-row>
        <nut-button block class="btn" @click="addRechargeRule()">添加一个充值规则</nut-button>
      </nut-row>
    </div>
    <nut-button block class="save-btn" @click="save">保存</nut-button>
  </div>
</template>

<script>
export default {
  name: 'RechargeRuleSet',
  data () {
    return {
      form: {
        id: null,
        rechargeRule: '',
      },
      rechargeRule: [{recharge: 0, money: 0}],
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData: function () {
      this.$api.post({
        url: '/device/api/device/device-config/find'
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          this.$util.ofData(this.form, res.data)
          if (!this.$util.isArrOrNull(res.data.rechargeRule)) {
            this.rechargeRule = JSON.parse(res.data.rechargeRule)
          }
        }
      })
    },
    addRechargeRule () {
      this.rechargeRule.push({recharge: 0, money: 0})
    },
    removeRechargeRule (index) {
      this.rechargeRule.splice(index, 1)
    },
    save () {
      this.form.rechargeRule = JSON.stringify(this.rechargeRule)
      this.$api.post({
        url: '/device/api/device/device-config/save',
        data: this.form,
      }).then(() => {
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500)
      })
    }
  }
}
</script>

<style scoped>
  .subject {
    margin: 0 15px;
  }

  .subject .title {
    height: 35px;
    line-height: 35px;
    margin-top: 5px;
    text-align: center;
    color: #848484;
  }

  .subject .input {
    margin: 5px 0;
  }

  .subject .btn {
    border-radius: 5px;
  }

  .save-btn {
    position: fixed;
    border-radius: 0;
    bottom: 0;
  }

  >>> .nut-button .txt-icon {
    color: #fff;
  }

  >>> .nut-textinput input {
    width: 70px;
  }

  >>> .nut-button {
    background: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/RechargeRuleSet.vue